<template>
    <section class="SideBar">
        <div class="bg-image">
            <ul>
                <li class="change-language">
                    <a href="#" @click.prevent="handleLanguageToggle">
                        {{ languageText }}
                    </a>
                </li>
                <li class="clc-logo">
                    <a :href="homeUrl">
                        <img 
                            src="../assets/images/rebrand-2026/att-connected-learning-center.svg" 
                            :alt="logoAlt" 
                        />
                    </a>
                </li>
                <li class="print-clc-name">
                    <p>{{ clcName }}</p>
                </li>
            </ul>
            <a class="arrowMobile" href="#CLCSite" @click="smoothScroll">
                <img src="../assets/images/rebrand-2026/arrowMobile.png" />
            </a>
        </div>
    </section>
</template>

<script>
export default {
    name: 'SideBar',
    props: {
        currentLanguage: {
            type: String,
            required: true,
            validator: (value) => ['en-us', 'es-es'].includes(value)
        },
        clcName: {
            type: String,
            default: 'Boys & Girls Club of Kumeyaay Nation Wellness - Southern Indian Health Council'
        }
    },
    computed: {
        languageText() {
            return this.currentLanguage === 'en-us' 
                ? 'Cambiar a Español' 
                : 'Switch to English';
        },
        logoAlt() {
            return this.currentLanguage === 'en-us'
                ? 'ATT Connected Learning Center'
                : 'Centro de aprendizaje conectado de ATT';
        },
        homeUrl() {
            const lang = this.currentLanguage === 'en-us' ? 'en' : 'es';
            return `/${lang}/`;
        }
    },
    methods: {
        handleLanguageToggle() {
            this.$emit('toggle-language');
        },
        smoothScroll(event) {
            event.preventDefault();
            const target = document.querySelector('.CLCSite') || document.querySelector('.News-detail-anchor');
            if (target) {
                const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({ 
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        }
    }
}
</script>
